import { Component, inject, ViewChildren, QueryList, ElementRef, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AdminHierarchyService } from 'src/app/services/admin-hierarchy.service';
import { HttpErrorResponse } from '@angular/common/http';
import { error } from 'console';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiResponse } from 'src/app/core/models/api-response.model';
import { BranchService } from 'src/app/services/branches.service';
import { ToastrService } from 'ngx-toastr';
import { BranchesInterface, Hierarchy } from 'src/app/util/uiNecessaryInterface';



@Component({
  selector: 'app-edit-branch',
  standalone: true,
  imports: [CommonModule, SharedModule, NgSelectModule, FormsModule, ReactiveFormsModule],
  templateUrl: './edit-branch.component.html',
  styleUrl: './edit-branch.component.scss'
})

export class EditBranchComponent implements OnInit {


  constructor(private modalService: NgbModal, private fb: FormBuilder) { }

  submittedData: boolean = false;
  admin_hierarchy: Hierarchy[] = [];
  form!: FormGroup;
  isSubmitted: boolean = false;
  modalRef!: NgbModalRef;
  branchId!: number;

  private adminHierarchyService = inject(AdminHierarchyService);
  private branchesService = inject(BranchService);
  private ngxLoader = inject(NgxUiLoaderService);
  private toastr = inject(ToastrService);


  @ViewChild('editBranchModal', { static: true }) editBranchModal!: TemplateRef<any>;

  // pass the value parent to child
  @Output() branchUpdated = new EventEmitter<void>();

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.form = this.fb.group({
      administrative_hierarchy_id: [null, Validators.required],
      name: ['', [Validators.required, Validators.maxLength(45)]],
      branch_code: ['', [Validators.required, Validators.maxLength(155)]],
    });
  }

  editBranchModalOpen(request: BranchesInterface) {
    this.modalRef = this.modalService.open(this.editBranchModal, { size: 'lg', centered: false, backdrop: 'static' });
    this.getAllHierarchy();
    console.log('request :', request);
    this.branchId = request.id
    this.patchValue(request)
    this.modalRef.dismissed.subscribe((() => {
      this.clearData();
    }))
  }

  patchValue(request: BranchesInterface) {
    this.form.patchValue({
      administrative_hierarchy_id: request.administrative_hierarchy_id,
      name: request.name,
      branch_code: request.code
    });
  }

  getAllHierarchy() {
    this.ngxLoader.start();
    this.adminHierarchyService.findAll().subscribe({
      next: (response: ApiResponse) => {
        this.admin_hierarchy = response.data.map((detail: { id: number, name: string }) => ({
          id: detail.id,
          name: detail.name
        }));
        this.ngxLoader.stop();
      }, error: (err: HttpErrorResponse) => {
        this.ngxLoader.stop()
        throw err;
      }
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.form.valid) {
      this.ngxLoader.start();
      const formData = this.form.getRawValue();
      console.log('yoo formData :', formData);

      this.branchesService.update(this.branchId, formData).subscribe({
        next: (response: ApiResponse) => {
          this.ngxLoader.stop();
          this.isSubmitted = false;
          this.clearData();
          this.modalRef.close();
          this.branchUpdated.emit()
          this.toastr.success("Branch updated successfully", "Success");
        }, error: (error: HttpErrorResponse) => {
          this.ngxLoader.start();
          throw error;
        }
      })
    }
  }

  clearData() {
    this.form.reset()
  }




}
